import { Effect } from "../../Materials/effect";
var name = 'subSurfaceScatteringFunctions';
var shader = "bool testLightingForSSS(float diffusionProfile)\n{\nreturn diffusionProfile<1.;\n}";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var subSurfaceScatteringFunctions = { name: name, shader: shader };
//# sourceMappingURL=subSurfaceScatteringFunctions.js.map